import { useCallback, useState, useMemo } from 'react';
import { DropDownListTw } from '../../../base/tw-components';
import { enums } from '../../../../utils';
import { useHistory } from 'react-router-dom';
import * as dm from '../../../../data-models';

export const isTaskNotCompleted = (task: dm.Task): boolean => {
  return (
    task.taskStatusId !== 7 &&
    task.taskStatusId !== 9 &&
    task.taskStatusId !== 10
  );
};

export const isTaskNotUpcomingOrOptional = (task: dm.Task): boolean => {
  return task.taskStatusId !== 1 && task.taskCategoryId !== 2;
};

const filterTasks = (
  tasks: dm.Task[],
  category: string,
  isTaskNotCompleted: (task: dm.Task) => boolean,
): dm.Task[] => {
  return tasks.filter(
    (t) => t.taskCategory === category && isTaskNotCompleted(t),
  );
};

const sortByDueDate = (a: dm.Task, b: dm.Task) =>
  new Date(a.taskDueDate).getTime() - new Date(b.taskDueDate).getTime();

const sortBySubmitDate = (a: dm.Task, b: dm.Task) =>
  new Date(b.submitDate).getTime() - new Date(a.submitDate).getTime();

export const sortAssignedTasks: Function = (tasks: dm.Task[]): dm.Task[] => {
  const requiredTasksNotComplete = filterTasks(
    tasks,
    'Required',
    isTaskNotCompleted,
  );
  requiredTasksNotComplete.sort(sortByDueDate);

  const recommendedTasksNotComplete = filterTasks(
    tasks,
    'Recommended',
    isTaskNotCompleted,
  );
  recommendedTasksNotComplete.sort(sortByDueDate);

  return requiredTasksNotComplete.concat(recommendedTasksNotComplete);
};

export const checkForRequiredTasks: Function = (tasks: dm.Task[]): boolean => {
  const requiredTasksNotComplete = filterTasks(
    tasks,
    'Required',
    (t) => isTaskNotCompleted(t) && isTaskNotUpcomingOrOptional(t),
  );

  return Boolean(requiredTasksNotComplete?.length);
};

export const sortReceivedTasksBySubmitDate: Function = (
  tasks: dm.Task[],
): dm.Task[] => {
  tasks.sort(sortBySubmitDate);

  return [...tasks];
};

///////////////////

const ACTIONS = {
  'Request Extension': (
    history: ReturnType<typeof useHistory>,
    NTNId: string,
  ) => {
    history.push({
      pathname: enums.AppPaths.extensionRequest,
      state: { ntnToOpen: NTNId },
    });
  },
  // Add more actions here for the actions dropdown:
} as const;

type ActionKey = keyof typeof ACTIONS;

type QuickActionsProps = {
  dataToPass: string;
};

export function QuickActionsDropDown({
  dataToPass,
}: Readonly<QuickActionsProps>) {
  const history = useHistory();

  const dropDownOptions = useMemo(
    () => Object.keys(ACTIONS) as ActionKey[],
    [],
  );

  const [dropDownValue, setDropDownValue] = useState<ActionKey | null>(null);

  const handleChange = useCallback(
    ({ value }: { value: ActionKey | null }) => {
      setDropDownValue(value);
      if (!value) return;

      ACTIONS[value](history, dataToPass);
    },
    [history, dataToPass],
  );

  return (
    <DropDownListTw<ActionKey>
      id="quick-action-dd"
      data={dropDownOptions}
      value={dropDownValue}
      onChange={handleChange}
      defaultItem="Quick actions"
    />
  );
}
